import React from "react";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Services } from "../../api/Services";
import ReactPaginate from "react-paginate";
import { BASE_URL_MEDIA } from "../../api/Constants";
import WorkoutDetails from "./WorkoutDetails";

const Workouts = ({ activeId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [workouts, setWorkouts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedWorkout, setSelectedWorkout] = useState(null);

  //api cfor quick workouts
  const getWorkOuts = async (activeId, page = 1) => {
    setIsLoading(true);
    try {
      const result = await Services.getUserQuickWorkouts(activeId, page);
      console.log("workoutss", result);
      if (result) {
        setIsLoading(false);
        setPageCount(result?.data?.data?.paging?.total_pages);
        setWorkouts(result?.data?.data?.listing);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWorkOuts(activeId);
  }, [activeId, pageCount]);
  // handle page count
  const handlePageClick = (event) => {
    getWorkOuts(event.selected + 1);
  };

  const handleShowWorkout = (workout) => {
    setSelectedWorkout(workout);
    setShowModal(true);
  };
  const showWorkoutDetails = () => {
    return (
      <WorkoutDetails workout={selectedWorkout} setShowModal={setShowModal} />
    );
  };
  return (
    <div className="quick-workouts">
      <ToastContainer />
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      {showModal && showWorkoutDetails()}
      <div className="">
        <div className="row">
          {workouts?.map((workout) => (
            <div className="col-12 col-md-6 col-lg-4">
              <div
                className="workout_wrapper pointer"
                onClick={() => handleShowWorkout(workout)}
              >
                <div className="top-section">
                  <div className="left">
                    <div className="icon-wrapper">
                      <i class="fa-regular fa-calendar-days"></i>{" "}
                      <span>{workout?.date?.slice(0, 10)}</span>
                    </div>
                    <div className="icon-wrapper">
                      <i class="fa-solid fa-user-tie"></i>{" "}
                      <span>{workout?.trainer_name}</span>
                    </div>
                    <div className="icon-wrapper">
                      <i class="fa-solid fa-location-dot"></i>{" "}
                      <span>{workout?.location}</span>
                    </div>
                  </div>
                  <div className="right">
                    {workout?.images?.length > 0 && (
                      <a
                        href={`${BASE_URL_MEDIA}/storage/assets/uploads/${workout?.images[0]?.image}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="pointer"
                          src={`${BASE_URL_MEDIA}/storage/assets/uploads/${workout?.images[0]?.image}`}
                          alt="Workout"
                        />
                      </a>
                    )}
                  </div>
                </div>
                {/* <p className="notes-title">Details:</p>
                {workout?.notes && <p className="notes">{workout?.details}</p>}
                <p className="notes-title">Notes:</p>
                {workout?.notes && <p className="notes">{workout?.notes}</p>} */}
              </div>
            </div>
          ))}
        </div>
      </div>

      {pageCount > 1 && (
        <div style={{ float: "right", marginTop: "20px", marginRight: "10px" }}>
          <nav aria-label="Page navigation example">
            <ReactPaginate
              className="pagination pull-right"
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="< "
              activeClassName="active"
              renderOnZeroPageCount={false}
            />
          </nav>
        </div>
      )}
    </div>
  );
};

export default Workouts;
